import { render, staticRenderFns } from "./roundSelect.vue?vue&type=template&id=82e8ffc6&scoped=true&"
import script from "./roundSelect.vue?vue&type=script&lang=ts&"
export * from "./roundSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e8ffc6",
  null
  
)

export default component.exports